class ProductBundlesForm extends HTMLElement {
    constructor() {
        super();

        this.flickity = window.theme.flickity
        this.dataBundle = window.productBundle

        this.btnsOpen = this.querySelectorAll('[data-bundle-open]')
        this.btnsClose = this.querySelectorAll('[data-bundle-close]')

        this.btnsAdd = this.querySelectorAll('[data-bundle-add]')

        this.addTocart = this.querySelector('[data-add-bundle-to-cart]')

        this.bundleIndexEls = this.querySelectorAll('[data-bundle-index]')

        this.btnsOpen.forEach(btn => btn.addEventListener('click', () => this.openBundleList(btn)))
        this.btnsClose.forEach(btn => btn.addEventListener('click', () => this.closeBundleList()))
        this.btnsAdd.forEach(btn => btn.addEventListener('click', () => this.addBundleList(btn)))
        this.addTocart.addEventListener('click',() => this.handleClick())

        this.initEdit()
        this.updateAddToCartBtn()
    }

    initEdit () {
        const url = new URL(window.location.href)
        const bundleID = url.searchParams.get("edit")
        const cart = window.cartJSON
        if (bundleID) {
            this.classList.add('loading')
            cart.items.forEach(item => {
                const dataBundle = item.properties['_bundle_details'].split('|')
                const isItem = item.properties && dataBundle[2] == bundleID
                if (isItem) {
                    const el = this.querySelector(`[data-bundle-handle="${item.handle}"]`)
                    if (el) el.click()
                }
            })
            this.updatePriceBundle()
            this.classList.remove('loading')
            this.addTocart.innerHTML = 'update bundle'
            this.addTocart.disabled = true
            this.addTocart.classList.add('update-bundle')
        }
    }

    handleClick () {
        const isBundleBtn = this.addTocart.classList.contains('update-bundle')
        if (isBundleBtn) {
            this.updateBundle()
        } else {
            this.addBundleToCart()
        }
    }

    async updateBundle () {
        this.classList.add('loading')
        let currentUrl = new URL(window.location)
        const bundleID = currentUrl.searchParams.get("edit")
        let keys = []
        const cart = window.cartJSON
        cart.items.forEach(item => {
            if(item.properties['_bundle_details'] ){
                const bundleDetails = item.properties['_bundle_details'].split('|')
                if(bundleDetails[2] === bundleID) keys.push(item.key)
            }
        })
        const newTimeStamp = new Date().getTime()
        let updates = {}
        keys.forEach(i => updates[i] = 0)
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        await this.addBundleToCart(newTimeStamp)
        currentUrl.searchParams.set('edit', newTimeStamp)
        currentUrl.search = currentUrl.searchParams;
        currentUrl        = currentUrl.toString();
        history.pushState({}, null, currentUrl)
        this.classList.remove('loading')
        this.initEdit()
    }

    async addBundleToCart (time) {
        this.classList.add('loading')
        const timeStamp = time ? time :new Date().getTime()
        let itemData = []

        let originalBundlePrice = 0
        let variants = []

        let bundlePrice = this.dataBundle.price

        let bundleImage = this.dataBundle.image

        this.bundleIndexEls.forEach(el => {
            const price = parseInt(el.getAttribute('data-item-price'))
            originalBundlePrice += price
            variants.push(
                {
                    'id' : el.getAttribute('data-item-variant'),
                    'price': price
                }
            )
        })

        if (this.dataBundle.variants.length > 1) {
            const variantSelected = this.dataBundle.variants.find(variant => variant.compare_at_price === originalBundlePrice)
            if(variantSelected) {
                bundlePrice = variantSelected.price
                bundleImage = variantSelected.featured_image ? variantSelected.featured_image.src : this.dataBundle.image
            }
        }

        const totalDiscounted = originalBundlePrice - bundlePrice
        const percentDiscount = totalDiscounted / originalBundlePrice
        let calcDiscounted = 0

        variants = variants.reduce((acc, item) => {
            if (!acc[item.id]) {
                acc[item.id] = { id: item.id, price: item.price, quantity: 0 };
            }
            acc[item.id].quantity += 1;
            return acc;
        }, {});

        variants = Object.values(variants)

        variants.forEach((variant, index) => {
            let item = {}
            const variantQuantity = variant.quantity ? variant.quantity : 1
            item['id'] = variant.id
            item['quantity'] = variantQuantity

            let properties = {}
            let discountPrice = 0
            if(variants.length === 1) {
                discountPrice = totalDiscounted
            } else if (index < variants.length - 1) {
                discountPrice = Math.round(variant.price * percentDiscount) * variantQuantity
                calcDiscounted += discountPrice
            } else {
                discountPrice = totalDiscounted - calcDiscounted
            }
            properties['_bundle_details'] = `${discountPrice}|${this.dataBundle.title}|${timeStamp}|${bundlePrice}-${originalBundlePrice}|${bundleImage}|${this.dataBundle.handle}`
            item['properties'] = properties

            itemData.push(item)
        })

        let formData = {
            'items': itemData
        };

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        window.cart.getCart()
        this.classList.remove('loading')
    }

    updateAddToCartBtn() {
        let isAllReady = true
        this.bundleIndexEls.forEach(item =>{
            if (item.getAttribute('data-item-variant') === '') isAllReady = false
        })
        const isBundleBtn = this.addTocart.classList.contains('update-bundle')

        if(isAllReady) {
            isBundleBtn ? this.addTocart.innerHTML = 'update bundle' : this.addTocart.innerHTML = 'add to cart'
            this.addTocart.disabled = false
        }else {
            this.addTocart.innerHTML = 'select item'
            this.addTocart.disabled = true
        }
    }

    updatePriceBundle () {
        let originalBundlePrice = 0

        let bundlePrice = this.dataBundle.price

        const els = [...this.bundleIndexEls]
        const isNotReady = els.some(el => el.getAttribute('data-item-variant') === '')
        if(isNotReady) return

        els.forEach(el => {
            originalBundlePrice += parseInt(el.getAttribute('data-item-price'))
        })

        if (this.dataBundle.variants.length > 1) {
            const variantSelected = this.dataBundle.variants.find(variant => variant.compare_at_price === originalBundlePrice)
            if(variantSelected) bundlePrice = variantSelected.price
        }

        const priceEl = document.querySelector('[data-product-price]')
        const compareAtPRiceEl = document.querySelector('[data-compare-price]')
        if(priceEl) priceEl.innerHTML = window.theme.currency.formatMoney(bundlePrice, theme.moneyFormat)
        if(compareAtPRiceEl && originalBundlePrice > bundlePrice) compareAtPRiceEl.innerHTML = window.theme.currency.formatMoney(originalBundlePrice, theme.moneyFormat);
    }

    openBundleList(el) {
        document.body.classList.add('modal--bundle')
        const id = el.getAttribute('data-bundle-open')
        const bundleListEl = this.querySelector(`[data-bundle-items="${id}"]`)
        const slider = bundleListEl.querySelector('[data-bundle-slider]')
        const slideItems = slider.querySelectorAll('.bundle__item-item').length
        bundleListEl.classList.add('active')
        const windowWidth = window.innerWidth

        const itemActiveSlide = windowWidth < 640 ? 2 : windowWidth < 1024 ? 3 : 4
        if(slideItems > itemActiveSlide) {
            let newSlide = new this.flickity(slider, {
                prevNextButtons: true,
                cellAlign: 'left',
                selectedAttraction: 0.2,
                friction: 1
            })
        }
    }

    closeBundleList() {
        document.body.classList.remove('modal--bundle')
        const bundleList = this.querySelector('[data-bundle-items].active')
        if (bundleList) bundleList.classList.remove('active')
    }

    addBundleList(el) {
        const id = el.getAttribute('data-bundle-add')
        const index = el.getAttribute('data-add-item')
        const product = JSON.parse(el.getAttribute('data-bundle-product'))

        const itemIndexEls = this.querySelectorAll(`[data-bundle-items="${id}"] [data-item-index]`)

        if (itemIndexEls) itemIndexEls.forEach((item) => {
            item.getAttribute('data-item-index') === index ? item.classList.add('selected') : item.classList.remove('selected')
        })


        const bundleEl = this.querySelector(`[data-bundle-index="${id}"]`)
        const nameEl = bundleEl.querySelector('[data-bundle-name]')
        const imageEl = bundleEl.querySelector('[data-bundle-image]')

        nameEl.innerHTML = product.title
        imageEl.setAttribute('src', product.featuredImage)
        bundleEl.setAttribute('data-item-variant', product.initVariant.id)
        bundleEl.setAttribute('data-item-price', product.initVariant.price)
        bundleEl.classList.add('active')
        this.closeBundleList()
        this.updateAddToCartBtn()
        this.updatePriceBundle()
    }
}

customElements.define('product-bundles-form', ProductBundlesForm);